module.exports = __webpack_public_path__ + "static/media/tg.3ec63502.svg";